export default {
  namespaced: true,
  state: {
    errorAlerts: [],
  },
  getters: {
    getErrorAlerts: state => state.errorAlerts,
  },
  mutations: {
    SET_ERROR_ALERTS(state, val) {
      state.errorAlerts = val
    },
  },
  actions: {},
}
